import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { colors } from "../theme/colors";
import InspiraLogo from "../assets/svg/incon_inspira.svg";
import { useLocation, useNavigate } from "react-router-dom";

import ResultBackground from "../assets/svg/banner_pagado.svg";

export default function Header() {
  const [infoPage, setinfoPage] = useState();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    pathname === "/info" ? setinfoPage(true) : setinfoPage(false);
  }, [pathname]);

  const segments = pathname.split("/").filter(Boolean);
  const isEnglish = segments[0] === "en";
  const page = isEnglish ? segments[1] : segments[0];

  return (
    <Box
      sx={{
        height: {
          xs:
            page === "details" || page === "pay"
              ? "235px"
              : page === "result"
                ? "177px"
                : "100px",
          md:
            page === "details" || page === "pay"
              ? "235px"
              : page === "result"
                ? "642px"
                : "100px",
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor:
          page === "result" ? "transparent" : colors.headerbk,
        backgroundImage:
          page === "result"
            ? `url(${ResultBackground})`
            : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {page !== "result" && (
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item sm={1}></Grid>
          <Grid item sm={3}></Grid>
          <Grid
            item
            sm={4}
            style={{ textAlign: "center", marginTop: "1rem" }}
            onClick={() => navigate(isEnglish ? "/en" : "/")}
            sx={{ "&:hover": { cursor: "pointer" } }}
          >
            <img
              src={InspiraLogo}
              alt="Inspira-Airlines"
              style={{ maxWidth: "100%" }}
            />
          </Grid>
          <Grid item xs={0} sm={4} md={2}></Grid>
          <Grid
            item
            xs={6}
            sm={3}
            md={2}
            sx={{ paddingTop: "0 !important", textAlign: "center" }}
          ></Grid>
        </Grid>
      )}
    </Box>
  );
}
